import React from "react";
import { useTranslation } from "react-i18next";
import { InformationCircleIcon, XMarkIcon } from "@heroicons/react/24/outline";

interface BetaBannerProps {
  onClose: () => void;
}

const BetaBanner: React.FC<BetaBannerProps> = ({ onClose }) => {
  const { t } = useTranslation("dashboard");

  return (
    <div className="flex min-h-10 w-full shrink-0 items-center gap-2 bg-[var(--colors-yellow-400,#FACC15)] px-6 py-2.5 font-['Plus_Jakarta_Sans'] text-sm font-medium leading-5 text-zinc-900">
      <InformationCircleIcon className="h-4 w-4 shrink-0" />
      <p className="flex-1">{t("beta_banner_message")}</p>
      <button
        type="button"
        onClick={onClose}
        aria-label={t("close")}
        className="shrink-0"
      >
        <XMarkIcon className="h-4 w-4" />
      </button>
    </div>
  );
};

export default BetaBanner;
